module.exports = __webpack_public_path__ + "img/report.9096ea2b.svg";